export const NOTIFICATION_STATUS = {
  PENDING: 'Lên lịch',
  SEND: 'Đã gửi'
} as const;

export const RECEIVER_TYPE = {
  ALL: 'Tất cả',
  ADJUST: 'Người dùng tuỳ chỉnh'
} as const;

export type NotificationStatusKey = keyof typeof NOTIFICATION_STATUS;
export type ReceiverTypeKey = keyof typeof RECEIVER_TYPE;

export const convertFrequencyTimesToOptions = (data: FrequencyTimeItem[]) =>
  data.map((item) => ({
    value: item.ID,
    label: item.NAME
  }));

export const convertLinkFunctionsToOptions = (data: LinkFunctionItem[]) =>
  data.map((item) => ({
    value: item.ID,
    label: item.NAME
  }));

export const convertWeekDaysToOptions = (data: WeekDayItem[]) =>
  data.map((item) => ({
    value: item.ID,
    label: item.NAME
  }));

export const convertTargetGroupsToOptions = (data: TargetGroupItem[]) =>
  data.map((item) => ({
    value: item.ID,
    label: item.DISPLAY_NAME
  }));

export const getNotificationStatusOptions = () =>
  Object.entries(NOTIFICATION_STATUS).map(([key, value]) => ({
    value: key,
    label: value
  }));

export const getReceiverOptions = () =>
  Object.entries(RECEIVER_TYPE).map(([key, value]) => ({
    value: key,
    label: value
  }));
